import React from "react";
import classNames from "classnames";
import {safeHTML} from "../../utils/safeHTML";
import {defaultNarrativeColor} from "../../constants/copyright";
import {useModal} from "../../hooks/useModal";
import {useDispatch} from "react-redux";
import {changeActiveStoryId} from "../../redux/reducer/panel";
import styles from "./Narratives.module.scss";

const NarrativesItem = React.forwardRef(
  function NarrativesItem({index, tags, title, image, imageM, color, className}, ref) {

    const dispatch = useDispatch();

    return (
      <div className={classNames(styles.narratives__item, className, {
        [styles.narratives__item_blackText]:color=== "white",
        "narratives__item_black-text": color === "white"
      })}
           style={{
             "--color": `${color || defaultNarrativeColor}`
           }}
           ref={ref}
           onClick={() => {
             dispatch(changeActiveStoryId(index));
           }}
      >
        <div className={styles.narratives__itemImage}>
          {image &&
          <picture>
            <source srcSet={imageM} media={"(max-width:1023px)"}/>
            <img src={image} alt="" loading="lazy" width={272} height={360}/>
          </picture>

          }
        </div>
        {tags &&
        <div className={styles.narratives__itemTags}>
          {tags?.map((item, index) => (
            <div className={styles.narratives__itemTag} key={`tag-${index}`}>
              {safeHTML(item.text)}
            </div>
          ))}
        </div>}
        <div className={styles.narratives__itemTitle}>{safeHTML(title)}</div>
      </div>
    );
  });
export default NarrativesItem;
NarrativesItem.propTypes = {};

